import { observable, computed, action } from 'mobx';
import { unformat } from 'accounting';
import { IStockDetailsShown, IItemStockDetails, IItemStockWarehouseFromApi } from '../../../common/interfaces/stock';
import { app } from '../App';

export class StockDetails {

    @observable public stockDetails: IItemStockDetails[] = [];

    @computed public get stockDetailsItemCodes(): string[] {
        return this.stockDetails.map((item) => item.itemcode);
    }

    @observable public stockDetailsShown: IStockDetailsShown[] = [];

    @computed public get stockDetailsShownItemCodes(): string[] {
        return this.stockDetailsShown.map((item) => item.itemcode);
    }

    @action public showStockDetails = (itemcode: string) => {
        const itemExists = this.stockDetailsItemCodes.indexOf(itemcode);
        let itemIsShown = itemExists !== -1 ? this.stockDetailsShownItemCodes.indexOf(itemcode) : -1;

        if (itemIsShown === -1) {
            itemIsShown = this.stockDetailsShown.length;
            this.stockDetailsShown.push({
                itemcode,
                loading: itemExists === -1
            });
        }

        this.fetchStockDetails(itemcode);
    }

    @action public hideStockDetails = (itemcode: string) => {
        const itemIsShown = this.stockDetailsShownItemCodes.indexOf(itemcode);
        if (itemIsShown !== -1) {
            this.stockDetailsShown.splice(itemIsShown, 1);
        }
    }

    @action private fetchStockDetails = async (itemcode: string): Promise<boolean> => {
        try {
            const service = await app.service('stock-details');
            const itemStock = await service.find({ query: { itemcode: itemcode } }) as IItemStockWarehouseFromApi[];

            const itemStockMapped = itemStock.map((stock) => {
                const onHandStock: number = unformat(stock.OnHand);

                return {
                    whsCode: stock.WhsCode,
                    whsName: stock.WhsName,
                    onHand: onHandStock,
                    available: onHandStock >= 1
                };
            }).sort((a, b) => {
                if (a.whsCode > b.whsCode) {
                    return 1;
                } else if (a.whsCode < b.whsCode) {
                    return -1;
                } else {
                    return 0;
                }
            });

            const itemExists = this.stockDetailsItemCodes.indexOf(itemcode);

            if (itemExists !== -1) {
                this.stockDetails[itemExists].warehouses = itemStockMapped;
            } else {
                this.stockDetails.push({
                    itemcode,
                    warehouses: itemStockMapped
                });
            }

            const itemIsShown = this.stockDetailsShownItemCodes.indexOf(itemcode);
            if (itemIsShown !== -1) {
                this.stockDetailsShown[itemIsShown].loading = false;
            }

            return true;
        } catch (err) {
            console.error(err);
            return err;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/StockDetails.ts